import type { FCl } from 'react-fc';

// use this directly in places where a component can't be used (such as a translation placeholder)
export const getFormattedNumber = (
    value: number,
    decimalPlaces?: number,
    minDecimalPlaces?: number,
    isCompact: boolean = false,
    language: string = null
) => {
    const formatter = new Intl.NumberFormat(language ?? [], {
        minimumFractionDigits: minDecimalPlaces ?? decimalPlaces,
        maximumFractionDigits: decimalPlaces,
        notation: isCompact ? 'compact' : 'standard',
    });
    return formatter.format(value);
};

export const Number: FCl<{
    value?: number | null;
    zeroValue?: number | string | null;
    nullValue?: string | null;
    decimalPlaces?: number;
    includeSign?: boolean;
    suffix?: string;
}> = ({ className, value, zeroValue = 0, nullValue = '-', decimalPlaces, includeSign = false, suffix = '' }) => {
    let threshold = null;
    if (decimalPlaces) {
        threshold = Math.pow(10, -1 * decimalPlaces);
    }
    if (value === 0) {
        if (zeroValue === null) {
            return null;
        }
        if (typeof zeroValue === 'number') {
            zeroValue = `${includeSign ? '+' : ''}${getFormattedNumber(zeroValue, decimalPlaces)}${suffix}`;
        }
        return <span className={className}>{zeroValue}</span>;
    } else if (!value) {
        return nullValue ? <span className={className}>{nullValue}</span> : null;
    } else if (threshold && Math.abs(value) < threshold) {
        return (
            <span title={value.toString()}>
                &lt; {threshold}
                {suffix}
            </span>
        );
    }
    return (
        <span title={decimalPlaces ? value.toString() : undefined} className={className}>
            {includeSign && value >= 0 && '+'}
            {getFormattedNumber(value, decimalPlaces)}
            {suffix}
        </span>
    );
};
